module.exports = __webpack_public_path__ + "static/media/21_plantilla_rec_combo_duo_cp_stills_pet_500_aq_pom.b56139f4.png";